export const canBeTreatedAsBoolean = (value: string) => {
    return value?.trim().toLowerCase().match(/^(false|true)$/)
};

export const getStringAsBoolean = (value: string) => value?.trim().toLowerCase() === "true"
